<div class="widget-card group-breakdown-kpi-widget" [ngClass]="widthClass">
  <!-- Widget Header -->
  <div class="widget-header">
    <div class="chart-title">
      <span class="title-text">{{ widgetTitle }}</span>
    </div>
    <gains-ellipsis-menu 
      *ngIf="menuItems.length > 0" 
      class="ellipsis-button" 
      [menuItems]="menuItems" 
      (changeEvent)="handleMenuAction($event)">
    </gains-ellipsis-menu>
  </div>
  
  <!-- Aggregate Total Section -->
  <div class="aggregate-total-section">
    <div class="total-content">
      <span class="total-value" [attr.aria-label]="hasData ? ('Total ' + widgetTitle.toLowerCase() + ': ' + formattedTotal) : (widgetTitle + ' data not available')">
        {{ hasData ? formatNumber(totalValue) : '—' }}
      </span>
      <span class="total-label">{{ hasData ? (currencySymbol + ' total') : '' }}</span>
    </div>
  </div>

  <!-- Breakdown Section -->
  <div class="breakdown-section" *ngIf="hasData && breakdownItems.length > 0; else noDataTemplate">
    <!-- Divider -->
    <div class="divider"></div>

    <!-- Breakdown List -->
    <div class="breakdown-list">
      <div class="breakdown-item" *ngFor="let item of formattedBreakdownItems">
        <span class="breakdown-item__label" [title]="item.label">{{ item.label }}</span>
        <span class="breakdown-item__value">{{ item.formattedValue }}</span>
      </div>
    </div>
  </div>

  <!-- No Data Template -->
  <ng-template #noDataTemplate>
    <div class="divider"></div>
    <div class="breakdown-list">
      <div class="breakdown-item">
        <span class="breakdown-item__label">No data available</span>
        <span class="breakdown-item__value">—</span>
      </div>
    </div>
  </ng-template>
</div>
